import { tryCatch } from '@/lib/try-catch'
import {
  deleteMomentsChunksPayloadById,
  getMomentsChunksPayload,
} from '@/local-db/moments-chunks'
import { CreateManyMomentChunksInput } from '@/trpc/types'
import { vanillaApiClient } from '@/trpc/vanilla'
import { encrypt } from '@/utils'

const onError = async ({
  error,
  id,
  message,
}: {
  error: Error
  id: number
  message: string
}) => {
  console.error(message, error)
  return await deleteMomentsChunksPayloadById(id)
}

export const generateAndSaveMomentsChunks = async () => {
  const payloads = await getMomentsChunksPayload()
  for (const payload of payloads) {
    const { data: generatedChunks, error: generateError } = await tryCatch(
      vanillaApiClient.ai.generateChunks.query({
        content: payload.textToEmbed,
      }),
    )

    if (generateError) {
      return onError({
        id: payload.id,
        error: generateError,
        message: 'Error generating chunks',
      })
    }

    const { embeddings, values } = generatedChunks

    const chunksToSave: CreateManyMomentChunksInput['chunks'] =
      await Promise.all(
        values.map(async (value: string, index: number) => ({
          chunkEmbeddings: embeddings[index],
          chunkEncrypted: await encrypt(value, payload.encryptKey),
          momentId: payload.momentId,
        })),
      )

    const { error: saveError } = await tryCatch(
      vanillaApiClient.momentChunks.createMany.mutate({
        chunks: chunksToSave,
      }),
    )

    if (saveError) {
      return onError({
        id: payload.id,
        error: saveError,
        message: 'Error saving chunks',
      })
    }

    await deleteMomentsChunksPayloadById(payload.id)
  }
}
